// extracted by mini-css-extract-plugin
export default {"VersionList":"VersionList_VersionList__ob0v+","SegmentedContent":"VersionList_SegmentedContent__0nPEk","new":"VersionList_new__t6ldo"};